export default {"src":"/_next/static/media/google-play-badge.01724a0d.svg","height":44,"width":149};